import appGlobalScript from '/home/vsts/work/1/s/packages/libs/component-library/src/global/app.ts';
export const globalScripts = appGlobalScript;
